import { LoginProvider } from '~/types';

export const AUTH_STORAGE_KEY = 'auth_info';
export const AUTH_EXPIRY_DAYS = 30; // 인증 정보 유효 기간 (일)

export interface AuthStorageInfo {
  lastAuthProvider: 'firebase' | 'cognito' | null;
  loginMethod: LoginProvider | null;
  lastLoginAt: number;
  email?: string;
}

export const saveAuthInfo = (info: AuthStorageInfo): void => {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(info));
};

export const getAuthInfo = (): AuthStorageInfo | null => {
  const data = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!data) return null;

  try {
    const authInfo = JSON.parse(data) as AuthStorageInfo;

    // 만료 확인 (30일)
    const now = Date.now();
    const expiryTime =
      authInfo.lastLoginAt + AUTH_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

    if (now > expiryTime) {
      clearAuthInfo();
      return null;
    }

    return authInfo;
  } catch {
    clearAuthInfo();
    return null;
  }
};

export const clearAuthInfo = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};
